import { z } from 'zod';
import { numberParameter } from './shared.js';

// SAGF: API 2026 Update 0.1 p89; Macro-PLUS p94. Coordinates are explicit;
// the native expression evaluates the surface rather than a Photonium grid.
const surfaceSagIndex = z.number().int().nonnegative().max(2147483647);
const surfaceSagSettings = z.strictObject({
  surface: surfaceSagIndex.describe('Native surface index; 0 is the object. CODE V validates surface existence.'),
  zoom: surfaceSagIndex.default(0).describe('Native zoom input, passed unchanged. Macro-PLUS p94: "If zoom_pos <1 or > (num z) then the first zoom position is used." The default 0 is that probed fallback: on a two-zoom lens, build 43679075 returned zoom 1\'s sag for 0 and a different sag for 2. It rejects out-of-range 99, so the >num z half is not native.'),
  points: z.array(z.strictObject({
    x: z.number().describe('X coordinate on the selected surface, in the loaded system length unit.'),
    y: z.number().describe('Y coordinate on the selected surface, in the loaded system length unit.'),
  })).min(1).describe('Explicit surface coordinates in input order. Repeated points remain repeated; no sampling grid is generated.'),
});
export default {
  label: 'Surface Sag', group: 'system',
  description: 'Surface sag at the X and Y points you enter.',
  settingsSchema: surfaceSagSettings,
  parameters: [
    numberParameter('surface', 'Surface', { integer: true, choices: 'surface', prominent: true }),
    numberParameter('zoom', 'Zoom (0 = first position)', { integer: true, hidden: true }),
    { key: 'points', label: 'Surface coordinates', kind: 'rows', prominent: true, columns: [
      numberParameter('x', 'X', { unit: 'system length' }),
      numberParameter('y', 'Y', { unit: 'system length' }),
    ] },
  ],
  coverage: 'One surface per run, in lens units. For a holographic surface, the sag is that of the substrate. If any point fails, the run fails and shows no values.',
} as const;
